import LocationDetailsPopover from './LocationDetailsPopover';
export default LocationDetailsPopover;
